export default function addStatisticsEventHandler({
  timeupdateHandler,
  readyState,
  seekHandler,
  pauseHandler,
  finishHandler,
}) {
  const video = document.getElementsByTagName('video')[0];

  function errorHandler(e) {
    video.removeEventListener('timeupdate', timeupdateHandler, false);
    video.removeEventListener('loadedmetadata', readyState, false);
    video.removeEventListener('seeked', seekHandler, false);
    video.removeEventListener('pause', pauseHandler, false);
    video.removeEventListener('timeupdate', timeupdateHandler, false);
    video.removeEventListener('ended', finishHandler, false);
  }

  video.addEventListener('timeupdate', timeupdateHandler, false);
  video.addEventListener('loadedmetadata', readyState, false);
  video.addEventListener('seeked', seekHandler, false);
  video.addEventListener('pause', pauseHandler, false);
  video.addEventListener('ended', finishHandler, false);
  video.addEventListener('error', errorHandler, false);

  return video;
}
